/**
 * Utility functions for sending admin notifications
 */

import { apiBaseUrl } from './api';

// Helper: agrega Authorization: Bearer <token> si existe REACT_APP_ADMIN_API_TOKEN
const adminAuthHeaders = () => {
  const token = process.env.REACT_APP_ADMIN_API_TOKEN;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Send notification when a listing is published
 * @param {Object} listing - The published listing
 * @param {Object} user - The user who published the listing
 * @param {string} listingType - Type of listing ('listing' or 'profile')
 */
export const notifyListingPublished = async (listing, user, listingType = 'listing') => {
  try {
    const response = await fetch(`${apiBaseUrl()}/api/admin/notify-listing-published`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/transit+json',
        ...adminAuthHeaders(),
      },
      body: JSON.stringify({
        listing,
        user,
        listingType,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    console.log('Admin notification sent:', result);
    return result;
  } catch (error) {
    console.error('Failed to send admin notification:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Send notification when someone shows interest in a need
 * @param {Object} need - The need listing
 * @param {Object} interestedUser - The user showing interest
 * @param {string} message - Optional message from the interested user
 */
export const notifyInterestInNeed = async (need, interestedUser, message = '') => {
  try {
    const response = await fetch(`${apiBaseUrl()}/api/admin/notify-interest-in-need`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/transit+json',
        ...adminAuthHeaders(),
      },
      body: JSON.stringify({
        need,
        interestedUser,
        message,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    console.log('Interest notification sent:', result);
    return result;
  } catch (error) {
    console.error('Failed to send interest notification:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Send notification when a need is accepted
 * @param {Object} need - The need listing
 * @param {Object} acceptedBy - The user who accepted the need
 * @param {Object} provider - The provider user
 */
export const notifyNeedAccepted = async (need, acceptedBy, provider) => {
  try {
    const response = await fetch(`${apiBaseUrl()}/api/admin/notify-need-accepted`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/transit+json',
        ...adminAuthHeaders(),
      },
      body: JSON.stringify({
        need,
        acceptedBy,
        provider,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    console.log('Need accepted notification sent:', result);
    return result;
  } catch (error) {
    console.error('Failed to send need accepted notification:', error);
    return { success: false, error: error.message };
  }
};
